<template>
  <div>
    <el-dialog
        :before-close="handleClose"
        :visible.sync="isAddStudentUpdateAlbumDialog"
        :show-close="true"
        :close-on-click-modal="false"
        width="70%"
        :top="'100px'"
        class="apply_kid_dialog"
    >
      <template #title>
        <div class="title_dialog">
          <span>Danh sách học sinh</span>
        </div>
      </template>

      <div class="body_dialog">
        <div class="section_filter">
          <el-row type="flex" :gutter="6">
            <el-col :span="6">
              <el-select
                  style="width: 90%"
                  v-model="classesApply"
                  multiple
                  filterable
                  allow-create
                  default-first-option
                  :limit="1"
                  @change="handleChangeFilter"
                  placeholder="Chọn lớp">
                <el-option
                    v-for="(item, index) in listClass"
                    :key="index"
                    :label="item.className"
                    :value="item.id">
                </el-option>
              </el-select>
            </el-col>

            <el-col :span="8" v-if="classesApply.length > 0">
              <el-input
                  :clearable="true"
                  style="width: 90%"
                  placeholder="Nhập tên học sinh"
                  v-model="nameKids"
                  @change="handleChangeFilter"
                  @clear="handleChangeFilter"
              >
                <template #append>
                  <el-button
                      icon="el-icon-search"
                      @click="handleChangeFilter"
                  ></el-button>
                </template>
              </el-input>
            </el-col>
          </el-row>
        </div>

        <div :class="kidsDataFilter.length === 0 ? 'wrap_data no_data' : 'wrap_data'">
          <div v-if="kidsDataFilter.length > 0">
            <div style="
              padding-bottom: 10px;
              margin-bottom: 10px;
              border-bottom: 1px solid #ccc;"
            >
              <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">
                Tất cả
              </el-checkbox>
            </div>
            <div style="height: 400px; overflow: auto">
              <div v-for="(item) in kidsDataFilter" :key="item.idClass">
                <el-divider content-position="left">
                  <div>
                    <i class="el-icon-star-on"/>
                    <span class="title_group">{{ item.className }}</span>
                  </div>
                </el-divider>
                <el-checkbox-group v-model="idKidApply">
                  <el-checkbox
                      style="width: 33.333333%;
                      margin-right: 0"
                      v-for="(kid) in item.students"
                      :label="kid.idKid" :key="kid.idKid"
                  >
                    {{ kid.kidsName }} - {{ parseKidStatusVietnamese(kid.statusKids) }} ({{ kid.className }})
                  </el-checkbox>
                </el-checkbox-group>
              </div>
            </div>
          </div>

          <div v-else style="color: #78a5e7">
            <i class="el-icon-warning"/>
            Không có dữ liệu
          </div>
        </div>
      </div>

      <template #footer>
        <div class="dialog-footer">
          <el-button @click="handleClose" type="danger">
            <i class="  el-icon-circle-close"/>
            Hủy bỏ
          </el-button>

          <el-button type="success" @click="handleSaveForm()">
            <i class="el-icon-circle-check"/>
            Xác nhận
          </el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>

import SurveyForm from "@/services/SurveyForm";
import {mapState} from "vuex";
import parseInfoKidVietnameseMixin from "@/global/mixinKid/parseInfoKidVietnamese.mixin";

export default {
  props: {
    isAddStudentUpdateAlbumDialog: {
      type: Boolean,
      default: () => false
    },
    getAppTypeUserLogin: {
      type: String,
      default: () => "school"
    },
    kidsInSchool: {
      type: Array,
      default: () => []
    },
  },
  computed: {
    ...mapState('classStore', ['classListCommon']),
    ...mapState('classStore', ['classInTeacher']),
    listClass() {
      if (this.$props.getAppTypeUserLogin === "plus") {
        return this.classListCommon;
      } else if (this.$props.getAppTypeUserLogin === "teacher") {
        return this.classInTeacher;
      }
      return [];
    },
  },
  data() {
    return {
      kidsDataFilter: [],
      classesApply: [],
      nameKids: "",
      idKidApply: [],
      checkAll: false,
      isIndeterminate: false
    }
  },

  watch: {
    classesApply(newVal, oldVal) {
      if (newVal.length < oldVal.length) {
        this.handleChangeKidsRemoveApply(newVal, oldVal);
      }
    },

    idKidApply(newVal) {
      if (newVal.length === this.parseDataFilterId(this.kidsDataFilter).length && this.parseDataFilterId(this.kidsDataFilter).length > 0) {
        this.checkAll = true;
        this.isIndeterminate = false;
      } else if (newVal.length === 0) {
        this.checkAll = false;
        this.isIndeterminate = false;
      } else if (newVal.length < this.parseDataFilterId(this.kidsDataFilter).length) {
        this.checkAll = false;
        this.isIndeterminate = true;
      }
    },

    kidsDataFilter(newVal) {
      if (this.parseDataFilterId(newVal).length > 0 && this.parseDataFilterId(newVal).length === this.idKidApply.length) {
        this.checkAll = true;
        this.isIndeterminate = false;
      } else if (this.idKidApply.length > 0 && this.parseDataFilterId(newVal).length > this.idKidApply.length) {
        this.checkAll = false;
        this.isIndeterminate = true;
      }

      this.handleChangeCheckApply();
    }
  },

  mixins: [
    parseInfoKidVietnameseMixin
  ],

  created() {
    this.fetchKidsInSchool();
  },
  methods: {
    handleClose() {
      this.$emit("closeDialog");
      this.resetData();
    },

    handleChangeCheckApply() {
      const idKidApply = this.idKidApply;
      const dataFilter = this.parseDataFilterId(this.kidsDataFilter);

      if (idKidApply.length > 0 && dataFilter.length > 0 && idKidApply.length > dataFilter.length) {
        const studentIds = dataFilter.map(student => student.idKid);

        this.idKidApply = idKidApply.filter(id => studentIds.includes(id));
      }
    },

    fetchKidsInSchool() {
      SurveyForm.getAllKidsSchool()
          .then((res) => {
            this.kidsInSchool = res.data.data;
          })
          .catch((err) => {
            console.log(err);
          })
    },

    handleCheckAllChange(val) {
      this.idKidApply = val ? this.getDataIdKids(this.parseDataFilterId(this.kidsDataFilter)) : [];
      this.isIndeterminate = false;
    },

    parseDataFilterId(dataFilter) {
      return dataFilter.flatMap(classItem => classItem.students);
    },

    getDataIdKids(kids) {
      const idKids = [];

      kids.map(kid => idKids.push(kid.idKid));

      return idKids;
    },

    // handleCheckedKidsChange(value) {
    //   let checkedCount = value.length;
    //   this.checkAll = checkedCount === this.kidsDataFilter.length;
    //   this.isIndeterminate = checkedCount > 0 && checkedCount < this.kidsDataFilter.length;
    // },

    getDataKidsApply(idKids) {
      return this.kidsInSchool.filter(kid => idKids.includes(kid.idKid));
    },

    handleChangeFilter(val) {
      if (val.length > 1) {
        // Giữ lại phần tử mới nhất hoặc cũ nhất, tuỳ yêu cầu
        this.classesApply = [val[val.length - 1]]; // giữ lại cái vừa chọn
      }
      const idClassList = this.classesApply;
      const name = this.nameKids;
      const kids = this.kidsInSchool;
      const result = [];

      idClassList.map((id) => {
        kids.map((kid) => {
          if (kid.idClass === id && name !== "") {
            if (this.removeVietnameseTones(kid.kidsName).includes(this.removeVietnameseTones(name))) {
              result.push(kid);
            }
          } else if (kid.idClass === id && name === "") {
            result.push(kid);
          }
        })
      })

      this.kidsDataFilter = this.groupKidsByIdClass(result);
    },

    groupKidsByIdClass(kids) {
      const groupedObj = {};

      kids.forEach(item => {
        if (!groupedObj[item.idClass]) {
          groupedObj[item.idClass] = {
            idClass: item.idClass,
            className: item.className,
            students: []
          };
        }
        groupedObj[item.idClass].students.push({
          idKid: item.idKid,
          kidsName: item.kidsName,
          statusKids: item.statusKids,
          idClass: item.idClass,
          className: item.className
        });
      });

      return Object.values(groupedObj);
    },

    removeVietnameseTones(str) {
      return str
          .normalize("NFD") // Tách các dấu tiếng Việt thành ký tự riêng
          .replace(/[\u0300-\u036f]/g, "") // Loại bỏ dấu
          .replace(/đ/g, "d")
          .replace(/Đ/g, "D")
          .toLowerCase(); // Chuyển về chữ thường
    },

    handleSaveForm() {
      console.log(this.idKidApply)
      const data = {
        classesApply: this.idKidApply.length === 0 ? [] : this.classesApply,
        kidsApply: this.getDataKidsApply(this.idKidApply),
      }

      this.$emit('confirmData', data);
      this.resetData();
    },

    initialDataApply(classes, kids) {
      this.classesApply = classes;
      this.idKidApply = kids;
      this.handleChangeFilter();
    },

    resetData() {
      this.kidsDataFilter = [];
      this.classesApply = [];
      this.nameKids = "";
      this.checkAll = false;
      this.isIndeterminate = false;
    },

    handleChangeKidsRemoveApply(newVal, oldVal) {
      const idRemovedValues = oldVal.filter(value => !newVal.includes(value));

      this.idKidApply = this.idKidApply.filter(kid => kid.idClass !== idRemovedValues[0])
    },
  }
}
</script>

<style lang="scss" scoped>
.title_dialog {
  font-size: 26px;
  font-weight: 600;
  color: #fff;
}

.apply_kid_dialog {
  /deep/ .el-dialog__header {
    background-color: #78a5e7;
    padding-top: 10px;
  }

  /deep/ .el-dialog__headerbtn:hover .el-dialog__close {
    color: #F56C6C;
  }
}

.wrap_data {
  min-height: 360px;
  border: 1px solid #ccc;
  margin-top: 14px;
  border-radius: 6px;
  padding: 10px 20px;
}

.no_data {
  display: flex;
  justify-content: center;
  align-items: center;
}

.title_group {
  font-size: 14px;
  font-weight: 700;
  font-family: system-ui;
  margin-left: 6px;
}
</style>